import clsx from 'clsx';

interface TikTokProps {
  className?: string;
}

const TikTok: React.FC<TikTokProps> = ({ className }) => {
  return (
    <svg
      className={clsx('tiktok', className)}
      fill="none"
      height="165"
      viewBox="0 0 100 165"
      width="100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="white" height="164" rx="7.5" width="99" x="0.5" y="0.5" />
      <rect height="164" rx="7.5" stroke="#D1D2D4" width="99" x="0.5" y="0.5" />
      <rect fill="white" height="149" width="84" x="8" y="8" />
      <rect fill="url(#paint0_linear_13416_26040)" fillOpacity="0.16" height="149" width="84" x="8" y="8" />
      <path d="M50 95C56.6274 95 62 89.6274 62 83C62 76.3726 56.6274 71 50 71C43.3726 71 38 76.3726 38 83C38 89.6274 43.3726 95 50 95Z" fill="black" />
      <path
        d="M48.4071 81.284V80.6328C47.3094 80.4825 46.1931 80.7057 45.2376 81.2667C44.2822 81.8276 43.5431 82.6936 43.1394 83.7253C42.7357 84.7571 42.6908 85.8947 43.0118 86.9551C43.3329 88.0155 44.0013 88.9371 44.9095 89.5716C44.2656 88.8745 43.8362 88.0066 43.6726 87.0718C43.509 86.137 43.6183 85.1749 43.9873 84.3006C44.3563 83.4262 44.9694 82.6767 45.7532 82.1418C46.5371 81.6068 47.4585 81.309 48.4071 81.284Z"
        fill="#25F4EE"
      />
      <path
        d="M48.5235 88.4777C49.7395 88.4777 50.7452 87.4969 50.7904 86.2921L50.7999 75.5485H52.748L52.7452 75.5321C52.7031 75.3078 52.6818 75.0802 52.6816 74.8521H49.9999L49.9956 85.6121C49.982 85.9928 49.8721 86.364 49.676 86.6907C49.48 87.0174 49.2042 87.2891 48.8745 87.4801C48.5449 87.6712 48.1721 87.7755 47.7912 87.7833C47.4102 87.791 47.0335 87.702 46.6964 87.5245C47.1048 88.0917 47.7707 88.4777 48.5235 88.4777Z"
        fill="#25F4EE"
      />
      <path
        d="M56.4175 79.2169V78.5865C55.6951 78.5872 54.9882 78.377 54.3835 77.9817C54.9051 78.5809 55.6135 79.0449 56.4175 79.2169Z"
        fill="#25F4EE"
      />
      <path
        d="M54.3836 77.9818C53.7902 77.304 53.4633 76.4338 53.4636 75.533H52.7336C52.8291 76.0314 53.0245 76.5053 53.3081 76.9261C53.5917 77.347 53.9575 77.7061 54.3836 77.9818Z"
        fill="#FE2C55"
      />
      <path
        d="M47.7411 83.2484C46.4967 83.2484 45.4695 84.2816 45.4695 85.5256C45.4695 86.3924 45.9759 87.1452 46.6943 87.5232C46.451 87.1867 46.3054 86.7894 46.2737 86.3752C46.242 85.9611 46.3254 85.5463 46.5146 85.1766C46.7039 84.8069 46.9917 84.4967 47.3462 84.2803C47.7008 84.0639 48.1082 83.9498 48.5235 83.9504C48.7496 83.951 48.9742 83.9862 49.1895 84.0548V81.314C48.9689 81.2829 48.7464 81.2667 48.5235 81.2656C48.4835 81.2656 48.4459 81.2676 48.4071 81.2688H48.3967L48.3895 83.3432C48.1797 83.278 47.9609 83.246 47.7411 83.2484Z"
        fill="#FE2C55"
      />
      <path
        d="M56.4175 79.1848L56.4047 79.1824V81.2552C55.0619 81.2519 53.754 80.8268 52.6659 80.04V85.5244C52.6637 86.4253 52.4152 87.3085 51.9472 88.0784C51.4793 88.8483 50.8097 89.4755 50.011 89.8923C49.2122 90.3091 48.3147 90.4995 47.4155 90.443C46.5164 90.3864 45.6498 90.0851 44.9095 89.5716C45.585 90.2986 46.4638 90.8052 47.4315 91.0254C48.3991 91.2456 49.4107 91.1691 50.3342 90.806C51.2578 90.4428 52.0505 89.8098 52.6089 88.9894C53.1674 88.1691 53.4658 87.1996 53.4651 86.2072V80.7512C54.5532 81.5333 55.8599 81.9532 57.1999 81.9512V79.268C56.9369 79.2679 56.6747 79.24 56.4175 79.1848Z"
        fill="#FE2C55"
      />
      <path
        d="M52.6824 85.5258V80.0702C53.7706 80.8523 55.0774 81.2721 56.4176 81.2702V79.185C55.6273 79.0144 54.9136 78.5922 54.3836 77.9818C53.9591 77.7057 53.595 77.3463 53.3135 76.9254C53.032 76.5044 52.839 76.0307 52.746 75.533H50.7804L50.776 86.293C50.7586 86.7622 50.5951 87.2143 50.3082 87.586C50.0213 87.9577 49.6254 88.2305 49.1758 88.3661C48.7263 88.5018 48.2456 88.4936 47.8009 88.3426C47.3563 88.1916 46.97 87.9055 46.696 87.5242C46.2489 87.2902 45.8932 86.913 45.6858 86.453C45.4783 85.993 45.4311 85.4768 45.5517 84.9868C45.6723 84.4968 45.9537 84.0614 46.3509 83.7502C46.7481 83.439 47.2382 83.27 47.7428 83.2702C47.9688 83.2708 48.1933 83.3058 48.4088 83.3742V81.269C45.7364 81.3314 43.5824 83.5202 43.5824 86.2074C43.5818 87.4566 44.0562 88.6594 44.9096 89.5718C45.6496 90.0909 46.5179 90.397 47.4199 90.4565C48.3219 90.5161 49.223 90.3269 50.0248 89.9095C50.8266 89.4921 51.4985 88.8626 51.9671 88.0896C52.4357 87.3166 52.6832 86.4297 52.6824 85.5258Z"
        fill="white"
      />
      <path d="M34 8H66C66 10.2091 64.2091 12 62 12H38C35.7909 12 34 10.2091 34 8Z" fill="white" />
      <rect fill="#EDEDEE" height="2" rx="1" width="10" x="43" y="8" />
      <rect fill="#EDEDEE" height="2" rx="1" width="2" x="55" y="8" />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_13416_26040" x1="50" x2="50" y1="8" y2="157">
          <stop stopColor="#FE2C55" />
          <stop offset="0.504808" stopColor="#9C2CFE" />
          <stop offset="1" stopColor="#25F4EE" />
        </linearGradient>
      </defs>
    </svg>
  );
};


export default TikTok;
